import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const LineItemDeleteButton = (_param)=>{
    var { className , onClick , 'aria-label': ariaLabel  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "onClick",
        'aria-label'
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("button", {
        onClick: onClick,
        "data-t": rest['data-t'],
        className: classnames('elements-line-item-delete', className),
        "aria-label": ariaLabel || getLabel('common.actions.delete')
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "trash",
        width: 16,
        height: 16
    }));
};

export { LineItemDeleteButton as default };
//# sourceMappingURL=LineItemDeleteButton.js.map
